import React from "react";
import { Link } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { resetListPages } from "../../features/listState/listStateSlice";
import { getLoggingUser } from "../../features/loggingUser/loggingUserSlice";
import { getVisibleModules, masterModules } from "../../static/modules";

const MasterModules = () => {
  const dispatch = useAppDispatch();
  const loggingUser = useAppSelector(getLoggingUser);

  const isSuperAdmin = !!loggingUser?.roles?.includes("Super Admin");

  const visibleModules = getVisibleModules(
    masterModules,
    loggingUser?.permissions,
    isSuperAdmin
  );

  if (visibleModules.length === 0) return null;

  return (
    <div className="mb-6 md:mb-8">
      <h2 className="text-base md:text-lg font-semibold text-[#113F67] mb-3 md:mb-4">
        માસ્ટર મોડ્યુલ
      </h2>

      <div className="grid gap-4 grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
        {visibleModules.map((masterModule) => (
          <Link
            key={masterModule.title}
            to={masterModule.href}
            onClick={() => dispatch(resetListPages(masterModule.listKey))}
          >
            <div className="rounded-lg bg-card text-card-foreground shadow-sm cursor-pointer transition-all duration-200 hover:shadow-lg hover:scale-105 border-2 hover:border-[#34699A] h-44 sm:h-48 md:h-56 lg:h-64 flex flex-col">
              <div className="flex flex-col space-y-1.5 p-6 text-center pb-2 md:pb-4 px-2 md:px-6 pt-3 md:pt-6">
                <div className="text-xl md:text-3xl lg:text-4xl mb-1 md:mb-2">
                  {masterModule.icon}
                </div>
                <div className="tracking-tight text-sm md:text-lg lg:text-xl font-bold text-[#113F67] leading-tight">
                  {masterModule.title}
                </div>
              </div>

              <div className="p-6 pt-0 text-center flex-1 flex flex-col justify-between px-2 md:px-6 pb-3 md:pb-6">
                <div className="text-xs md:text-sm text-gray-600 mb-2 md:mb-4 line-clamp-2 md:line-clamp-3">
                  {masterModule.description}
                </div>
                <button
                  type="button"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border h-9 rounded-md px-3 w-full border-[#34699A] text-[#34699A] hover:bg-[#34699A] hover:text-white bg-transparent text-xs md:text-sm lg:text-base py-1 md:py-2"
                >
                  ખોલો
                </button>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
export default MasterModules;
